export type ContextMenuOption = 'copy' | 'create' | 'delete';

export const ALL_CONTEXT_MENU_OPTIONS: ContextMenuOption[] = ['copy', 'create', 'delete'];
